import Icon from '@/components/base/Icon';

export const formatDataTableAndCSV = ({
    isExport = false,
    key,
    value,
    formatNumber,
    formatDateTime,
    formatHour,
    timeFormat,
    valueFormat,
    userDateFormat,
    translationFunc,
    formatterTranslation,
    isEstimatedChart = false
}) => {
    switch (key) {
        case 'date':
            return formatDateTime(value, userDateFormat);

        case 'date_hour':
            return formatHour(value);

        case 'time':
            return timeFormat(value);

        case 'post_engagements':
            return translationFunc(`chart.post_engagements.${value}`);

        case 'day':
            return translationFunc(`commons:days.${value}`);

        case 'month':
            return translationFunc(`chart.time_unit.${value}`);

        case 'age':
        case 'language':
        case 'country':
        case 'city':
        case 'name':
        case 'percentage_formatted':
        case 'domain':
            return value;

        case 'type':
            if (formatterTranslation) {
                return translationFunc(`${formatterTranslation}.${value}`);
            }
            return translationFunc(value);

        case 'reaction':
            return isExport ? (
                value
            ) : (
                <Icon
                    className="text-base text-icoGray-500 dark:text-icoDarkMode-wolf"
                    icon={`${value}-reaction`}
                />
            );
        case 'percentage_male':
        case 'percentage':
        case 'percentage_female':
            return formatNumber(value * 100, valueFormat) + '%';
        default:
            if (value || value === 0) {
                if (valueFormat) {
                    return formatNumber(value, valueFormat);
                }
                return value;
            }
            return isEstimatedChart ? '-' : 'N/A';
    }
};
